// extracted by mini-css-extract-plugin
export default {"flexAlignItemsInherit":"Autorenew-flexAlignItemsInherit_x4V7x","label":"Autorenew-label_JvvZL","PopoverIcon":"Autorenew-PopoverIcon_OKcaY"};